export default "__VITE_ASSET__DMV3ayDr__"